import { East } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import toList, { toHTML } from '../utils/ComponentUtil';
import CustomBreadcrumbs from '../utils/CustomBreadcrumbs';
import CustomButton from '../utils/CustomButton';
import Importance1 from '../../images/browse-jobs/main-img.png';
import Importance2 from '../../images/browse-jobs/sub-img.png';
import EligibilityImg from '../../images/browse-jobs/eligibility-img.png';
import PotentialImg from '../../images/browse-jobs/potential-img.png';
import MoneyImg from '../../images/browse-jobs/money-img.png';
import './BrowseJobs.scss';
import PointsCard from './PointsCard';
import JobDesc from '../DailyJobs/JobDesc';
import Header from '../utils/Header';
import CustomAccordion from '../utils/CustomAccordion';

function BrowseJobsDesc({ job }) {

  const breadcrumbs = [toList([{ to: "/", child: "Home" }, { to: "/home", child: "Browse Jobs" }], Link)
    , <Typography className="job-page-name">{job?.name}</Typography>]

  return (
    <div>
      <div className="browse-job-about-wrp wrapper">
        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
        <div className="about-container">
          <div className="about-wrp">
            <div className="title">
              About <div> {job?.name}</div>
            </div>
            <div className="content">{job?.about}</div>
            <CustomButton name="Start Working" icon={<East />} />
          </div>
          <div className="about-images-wrp">
            <div className="img-1">
              <img src={job?.aboutImages?.[0]} alt="about-1" />
            </div>
            <div className="img-2">
              <img src={job?.aboutImages?.[1]} alt="about-2" />
            </div>
          </div>
        </div>
      </div>
      {
        job?.skillsNeeded?.skills?.length > 0 && <div className="skills-needed-container">
          <div className="skills-needed-wrp wrapper">
            <div className="title">Skills needed for {job?.profession}s</div>
            <div className="skills">
              {toList(job?.skillsNeeded?.skills, undefined, (item, i) => (
                <div className="skill" key={i}>
                  <div className="point-wrp">
                    <div className="point"></div>
                    <div className="number">0{i + 1}</div>
                  </div>
                  <div className="name">{item}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
      {
        job?.benefits?.length > 0 && <div className="benefits-wrp wrapper">
          <div className="benefits-container">
            <div className="title">Benifits</div>
            <div className="benefits-card-wrp">
              {toList(job?.benefits, undefined, (item, i) => (
                <div className={"benefit-card "} key={i}>
                  <div className="img-wrp">
                    <img src={item.img} alt="benefit-img" />
                  </div>
                  <div className="content">
                    <span>{item.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
      {
        job?.importances?.length > 0 && <div className="importance-wrp wrapper">
          <div className="contents">
            <div className="images-wrp">
              <div className="main-img">
                <img src={Importance1} alt="main-img" />
              </div>
              <div className="sub-img">
                <img src={Importance2} alt="sub-img" />
              </div>
            </div>
            <div className="content">
              <div className="title">
                How important is the job of {job?.profession}s?
              </div>
              <div className="details">
                {toList(job?.importances, undefined, (item, i) => (
                  <div className="detail">
                    {item}
                    <br />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      }
      {
        job?.duties?.data?.length > 0 && <div className="duties-wrp wrapper">
          <div className="duties-container">
            <PointsCard
              title={"What are the duties of " + job?.profession + "s?"}
              subTitle={
                "Here are some of the duties that " + job?.profession + "s Experienced to accomplish:"
              }
              points={job?.duties?.data}
            ></PointsCard>
            <div className="potentital-wrp">
              <div className="content">{job?.duties?.description}</div>
              <div className="potential-img">
                <img src={PotentialImg} alt="potential-img" />
              </div>
            </div>
          </div>
        </div>
      }
      {
        job?.howItWorks?.details?.length > 0 && <div className="how-wrp wrapper">
          <div className="how-container">
            <div className="heading-wrp">
              <div className="title">How does it Work?</div>
              <div className="sub-title">{job?.howItWorks?.description}</div>
            </div>
            <div className="contents-wrp">
              {toList(job?.howItWorks?.details, undefined, (item, i) => (
                <div className="content-wrp">
                  {
                    item?.title && <div className="title-wrp">
                      <div className="point">
                        <div className="ellipse"></div>
                        <div className="number">0{i + 1}</div>
                      </div>
                      <div className="heading">{item.title}</div>
                    </div>
                  }
                  <div className="content">{item.detail}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
      {
        job?.eligibility?.eligibilities?.length > 0 && <div className="eligibility-wrp wrapper">
          <div className="eligibility-img">
            <img src={EligibilityImg} alt="eligibility-img" />
          </div>
          <PointsCard
            title={"Eligibility"}
            subTitle={job?.eligibility?.title}
            points={job?.eligibility?.eligibilities}
          ></PointsCard>
        </div>
      }
      {
        (job?.checks?.length > 0 || job?.expected?.length > 0) && <div className="expected-wrp wrapper">
          {
            job?.checks?.length > 0 && <div className="left-wrp">
              <PointsCard title={'What to look for in a ' + job?.profession + ' before hiring him for the job?'}
                subTitle={'Here are some points you need to check out before hiring a ' + job?.profession + ':'}
                points={job?.checks} />
            </div>
          }
          {
            job?.expected?.length > 0 && <div className="right-wrp">
              <PointsCard title={'What are the services that can be expected from a ' + job?.profession + '?'}
                subTitle={'A ' + job?.profession + ' can do the following:'}
                points={job?.expected} />
            </div>
          }
        </div>
      }
      {
        job?.faqs?.length > 0 && <div className='faq-wrp'>
          <JobDesc {...job?.recent} header={<Header title='Frequently Asked Question’s' subTitle='Clear your answers here' />}
            startPosting={false} bannerImg={false}
            render={() => <div className='faq-home-content-wrp'>
              <CustomAccordion accordians={toList(job?.faqs, undefined, (item, i) => {
                return {
                  summary: <div className='accordian-summary'>
                    <div className='question-no'>{i + 1}</div>
                    <div>{item.question}</div>
                  </div>,
                  details: <div className='accordian-details'>{toHTML(item.answer)}</div>
                }
              })}></CustomAccordion>
            </div>}></JobDesc>
        </div>
      }
      <div className="pay-methods-wrp wrapper" >
        <div className="pay-methods" >
          <div className="money-img" ><img src={MoneyImg} alt="money-img" /></div>
          <div className="content-wrp" >
            <div className="title" >Payment Methods</div>
            <div className="content" >UPI, direct account transfer, and PayPal are the common payment transfer options that we have for making payments to the candidates after successful completion of the assigned jobs.</div>
            <CustomButton name="Start Working" icon={<East />} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BrowseJobsDesc;